import React, { useEffect, useRef, useState } from "react";
import "./Productfilter.css";
import { useSelector } from "react-redux";
import "react-light-accordion/demo/css/index.css";
import {
  ActiveChips,
  BrandList,
  CategoryList,
  GenderList,
  PricePanel,
  SizeGrid,
  SortList,
} from "./FilterControls";
import { FILTER_BRANDS, buildActiveChips, filterGenderOptions, formatProductCount, getSingleSizeGroupLabel, sortLabel } from "../helper/filterOptions";

export default function Productmobilefilter(props) {
  const [filterMenu, setFilterMenu] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  const [openSection, setOpenSection] = useState(null);
  const sortRef = useRef(null);
  const sortInBar = !!props.sortInBar;

  useEffect(() => {
    if (!sortOpen) return;
    const close = (e) => {
      if (sortRef.current && !sortRef.current.contains(e.target)) setSortOpen(false);
    };
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, [sortOpen]);

  useEffect(() => {
    if (!sortInBar) return;
    const header = document.querySelector("header.header");
    if (!header || typeof ResizeObserver === "undefined") return;
    const setHeaderHeight = () => {
      document.documentElement.style.setProperty("--site-header-h", `${header.offsetHeight}px`);
    };
    setHeaderHeight();
    const ro = new ResizeObserver(setHeaderHeight);
    ro.observe(header);
    return () => ro.disconnect();
  }, [sortInBar]);

  const categoryValue = useSelector((state) => state?.category);
  const catData = categoryValue?.categories?.categoryList || [];

  const isDiscountPage = props.isDiscountPage || false;
  const activeOfferValue = props.activeOffer || "";
  const activeCategories = props.activeCategories || [];
  const activeBrands = props.activeBrands || [];
  const activeSubBrands = props.activeSubBrands || [];
  const activeSizes = props.activeSizes || [];
  const activeGender = props.activeGender;
  const activeSort = props.activeSort || "";
  const activeMinPrice = props.activeMinPrice;
  const activeMaxPrice = props.activeMaxPrice;
  const genderChoices = filterGenderOptions(props.availableGenders || []);
  const showGender = (props.pageType !== "products" || isDiscountPage) && (
    !props.facetStatus ||
    props.facetStatus === "error" ||
    (props.facetStatus === "ready" && genderChoices.length > 1)
  );
  const saleOn = String(activeOfferValue).toLowerCase() === "yes";
  const productCount = formatProductCount(props.productCount);

  const chips = buildActiveChips({
    catData,
    activeCategories,
    activeBrands,
    activeSubBrands,
    activeSizes,
    activeGender,
    activeOffer: isDiscountPage ? "" : activeOfferValue,
    activeMinPrice,
    activeMaxPrice,
  });

  const removeChip = (chip) => {
    if (chip.kind === "category") props.setCategoryPushData(chip.payload);
    if (chip.kind === "brand") props.setBrandPushData(chip.payload);
    if (chip.kind === "subbrand") props.setSubBrandPushData(chip.payload);
    if (chip.kind === "size") props.setSizePushData(chip.payload);
    if (chip.kind === "gender") props.setGenderPushData(undefined);
    if (chip.kind === "offer") props.setOfferPush(undefined);
    if (chip.kind === "price") props.setPricePushData(undefined, undefined);
  };

  const applySort = (value) => {
    const unchanged = value === "newest"
      ? !activeSort || activeSort === "newest"
      : activeSort === value;
    if (!unchanged) props.setSortPushData(value);
  };

  const accordionSections = [
    ...(sortInBar ? [] : [{
      key: "sort",
      title: "Rendit",
      content: <SortList activeSort={activeSort} onChange={applySort} />,
    }]),
    {
      key: "categories",
      title: "Kategoritë",
      content: (
        <CategoryList
          catData={catData}
          activeCategories={activeCategories}
          onToggle={props.setCategoryPushData}
          facetStatus={props.facetStatus}
          availableCategoryIds={props.availableCategoryIds}
        />
      ),
    },
    {
      key: "sizes",
      title: "Madhësia",
      content: (
        <SizeGrid
          selected={activeSizes}
          onToggle={props.setSizePushData}
          facetStatus={props.facetStatus}
          availableSizes={props.availableSizes}
          singleGroupLabel={getSingleSizeGroupLabel(catData, activeCategories)}
          sizesByCategory={props.availableSizesByCategory}
          catData={catData}
          activeCategories={activeCategories}
        />
      ),
    },
  ];

  if (showGender) {
    accordionSections.push({
      key: "gender",
      title: "Gjinia",
      content: (
        <GenderList
          activeGender={activeGender}
          onChange={props.setGenderPushData}
          facetStatus={props.facetStatus}
          availableGenders={props.availableGenders}
        />
      ),
    });
  }

  accordionSections.push({
    key: "price",
    title: "Çmimi",
    content: (
      <PricePanel
        min={activeMinPrice}
        max={activeMaxPrice}
        onChange={props.setPricePushData}
      />
    ),
  });

  if (props.pageType !== "brand") {
    accordionSections.splice(1, 0, {
      key: "brands",
      title: "Brendi",
      content: <BrandList brands={FILTER_BRANDS} selected={activeBrands} onToggle={props.setBrandPushData} />,
    });
  }

  if (props.pageType === "brand" && Array.isArray(props.availableSubBrands) && props.availableSubBrands.length > 0) {
    accordionSections.unshift({
      key: "subbrand",
      title: "Brendi",
      content: (
        <BrandList
          brands={props.availableSubBrands}
          selected={activeSubBrands}
          onToggle={props.setSubBrandPushData}
        />
      ),
    });
  }

  return (
    <>
      <div className="col-filter block lg:hidden">
        <div className="container mx-auto collection">
          <div className={`mg-filter js-products-filter ${sortInBar ? "mg-filter--bar" : ""}`}>
            <button
              type="button"
              className={sortInBar ? `filter-menu__btn ${chips.length ? "has-selection" : ""}` : "mg-filter__btn_yellow px-4"}
              onClick={() => setFilterMenu(!filterMenu)}
            >
              {sortInBar && (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
                  <path d="M4 7h10M18 7h2M4 17h4M12 17h8" />
                  <circle cx="16" cy="7" r="2" />
                  <circle cx="10" cy="17" r="2" />
                </svg>
              )}
              <span>Filtro{chips.length ? ` (${chips.length})` : ""}</span>
            </button>
            {sortInBar && (
              <div className="filter-menu filter-menu--end" ref={sortRef}>
                <button
                  type="button"
                  className={`filter-menu__btn ${sortOpen ? "is-open" : ""}`}
                  aria-expanded={sortOpen}
                  onClick={() => setSortOpen((o) => !o)}
                >
                  <span>{`Rendit: ${sortLabel(activeSort)}`}</span>
                  <span className="filter-menu__caret" aria-hidden="true">{sortOpen ? "▴" : "▾"}</span>
                </button>
                {sortOpen && (
                  <div className="filter-panel">
                    <SortList
                      activeSort={activeSort}
                      onChange={(value) => {
                        applySort(value);
                        setSortOpen(false);
                      }}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={filterMenu ? "filterss MobileNavigationContent MobileNavigationContent--open block lg:hidden mobile-display mobile-new-navigation" : "MobileNavigationContent MobileNavigationContent--open block lg:hidden"}>
        <div className="MobileNavigationContent__wrapper">
          <div className="mobile-nav-tab">
            <button className="close" onClick={() => setFilterMenu(!filterMenu)}></button>
            <div className="filter-drawer-head">
              <h2>Filtro</h2>
              {productCount && <span className="filter-count">{productCount}</span>}
            </div>
            <div className="filter-drawer-chips">
              <ActiveChips
                chips={chips}
                onRemove={removeChip}
                onClear={() => {
                  props.filterBtn();
                  props.resetFilter();
                }}
              />
            </div>
            {!isDiscountPage && (
              <label className={`filter-sale-row ${saleOn ? "has-selection" : ""}`}>
                <span>Zbritje</span>
                <input
                  type="checkbox"
                  checked={saleOn}
                  onChange={() => props.setOfferPush(saleOn ? undefined : "yes")}
                />
              </label>
            )}
            <div className="accordion">
              {accordionSections.map((section) => {
                const isOpen = openSection === section.key;
                return (
                  <div key={section.key} className={`accordion-item ${isOpen ? "active" : ""}`}>
                    <button
                      type="button"
                      className="title"
                      aria-expanded={isOpen}
                      onClick={() => setOpenSection(isOpen ? null : section.key)}
                    >
                      {section.title}
                    </button>
                    <div className="panel">
                      <div className={`accordion-content-${section.key}`}>
                        {section.content}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={{ padding: "10px 15px", display: "flex", justifyContent: "space-between", gap: "10px" }}>
              <button
                className="mg-filter__btn_transparent px-4 clear js-filter-clear-btn"
                onClick={() => {
                  props.filterBtn();
                  props.resetFilter();
                }}
              >
                Pastro
              </button>
              <button
                className="mg-filter__btn_apply px-4"
                onClick={() => {
                  props.filterBtn();
                  setFilterMenu(false);
                }}
              >
                Apliko
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
